import React from 'react';
import {
  WfbAdsSectionLoaderWrapper,
} from '@fuww/library/src/Articles/Sections/WfbAds';
import WfbAdsLoader from '../../Company/WfbAdsLoader';

const WfbAdsSectionLoader = () => (
  <WfbAdsSectionLoaderWrapper>
    <WfbAdsLoader />
  </WfbAdsSectionLoaderWrapper>
);

export const wfbAdsSectionLoading = () => <WfbAdsSectionLoader />;

export default WfbAdsSectionLoader;
